import { useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

import { useGetUsersInfiniteQuery } from 'src/apiClients';
import type { QueryWhereValue, UserListItem } from 'src/apiClients/queries';
import { SortDirection } from 'src/components/data-table/DataTable.types';
import { EntityListPage } from 'src/components/entity-list-page';
import { i18n as routesI18n } from 'src/hooks/use-imago-mp-routes.i18n';
import { createUserColumns, mapUserRow } from 'src/pages/users-page/user-table-formatters';
import { userTableI18n } from 'src/pages/users-page/user-table-formatters.i18n';

import { useInstance } from '../../InstanceContext';
import { SectionHeading } from '../SectionHeading';
import { i18n } from './UsersSection.i18n';

const SEARCH_COLUMNS = ['login', 'email', 'id', 'seequentUserId'];
const INITIAL_SORT = [{ field: 'state', direction: SortDirection.Asc }];

export const UsersSection = () => {
    const intl = useIntl();
    const { subscription } = useInstance();
    const [total, setTotal] = useState<number | undefined>(undefined);

    const baseWhere = useMemo<Record<string, QueryWhereValue>>(
        () => ({ subscriptionId: subscription.id }),
        [subscription.id],
    );

    const columns = useMemo(() => createUserColumns(intl), [intl]);

    const handleTotalChange = useCallback((next: number) => setTotal(next), []);

    return (
        <>
            <SectionHeading
                title={intl.formatMessage(routesI18n.instanceSectionUsers)}
                count={total}
                automationId="instance-users-count"
            />
            <EntityListPage<UserListItem>
                automationId="instance-users-section"
                useQuery={useGetUsersInfiniteQuery}
                searchColumns={SEARCH_COLUMNS}
                initialSort={INITIAL_SORT}
                columns={columns}
                mapRow={mapUserRow}
                baseWhere={baseWhere}
                disableScrollbarGutter
                onTotalChange={handleTotalChange}
                titleWhenNoResults={intl.formatMessage(userTableI18n.noUsersTitle)}
                messageWhenNoResults={intl.formatMessage(i18n.noUsersMessage)}
                titleWhenLoadError={intl.formatMessage(userTableI18n.loadErrorTitle)}
                messageWhenLoadError={intl.formatMessage(userTableI18n.loadErrorMessage)}
            />
        </>
    );
};
